import { ReactElement } from 'react'
import CardProps from './Card.props'
import * as S from './style'

export default function Card ({ className, children }: CardProps): ReactElement {
  return <S.CardContainer className={className}>{children}</S.CardContainer>
}
